import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';

import { graphChangeLoading } from 'modules/filter';
import { localMonthReport } from 'lib/api/localreport';
import { makeRowColumn, getHeadObj, cenversionTpCode } from 'lib/commonLib';

import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import NewTableContainer from 'components/molecules/NewTable';

import StatisticsMonthGraph from './StatisticsMonthGraph';

const StatisticsMonth = ({ location }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isPopPage = queryString.parse(location.search).isPop === '1';

  const initParams = {
    sort: 'desc',
    order: 'STATS_MTH',
    pltfomTpCode: 'all',
    itlTpCode: 'all',
    sumSub: 1,
    sDate: moment().add(-30, 'day').format('YYYYMMDD'),
    eDate: moment().format('YYYYMMDD'),
  };

  const [params, setParams] = useState(initParams);
  const [initialization, setInitialization] = useState(false);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  const customized = {
    STATS_MTH: {
      makeBody: (rowObj, headsMap) => {
        return rowObj['STATS_MTH'] === 'total'
          ? rowObj['STATS_MTH']
          : !!rowObj['PLTFOM_TP_CODE']
          ? cenversionTpCode(rowObj.PLTFOM_TP_CODE)
          : moment(String(rowObj['STATS_MTH'])).format('YYYY년 MM월');
      },
    },
    UM_PAR_EPRS_CNT: {
      makeHead: (headsMap) => {
        return <>{t('성향')}</>;
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'UM_PAR_EPRS_CNT');
        const bodyItem2 = getHeadObj(headsMap, 'UM_PAR_EPRS_RATE');
        return (
          <>
            {makeRowColumn(
              rowObj['UM_PAR_EPRS_CNT'],
              bodyItem1.type,
              bodyItem1.format
            )}
            {!rowObj['isChild'] && !!rowObj['UM_PAR_EPRS_RATE'] && (
              <>
                {' '}
                (
                {makeRowColumn(
                  rowObj['UM_PAR_EPRS_RATE'],
                  bodyItem2.type,
                  bodyItem2.format
                )}
                )
              </>
            )}
          </>
        );
      },
    },
    UM_PAR_EPRS_RATE: { merged: true },
    AD_PAR_EPRS_CNT: {
      makeHead: (headsMap) => {
        return <>{t('베이스광고')}</>;
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'AD_PAR_EPRS_CNT');
        return (
          <>
            {makeRowColumn(
              rowObj['AD_PAR_EPRS_CNT'],
              bodyItem1.type,
              bodyItem1.format
            )}
            {!rowObj['isChild'] && !!rowObj['AD_PAR_EPRS_RATE'] && (
              <>
                {' '}
                (
                {makeRowColumn(
                  rowObj['AD_PAR_EPRS_RATE'],
                  bodyItem1.type,
                  bodyItem1.format
                )}
                )
              </>
            )}
          </>
        );
      },
    },
    AD_PAR_EPRS_RATE: { merged: true },
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    if (JSON.stringify(params) !== JSON.stringify(initParams)) {
      setInitialization(true);
      setParams(initParams);
      if (isPopPage && window.location.search !== '?isPop=1') {
        window.location.replace(window.location.pathname + '?isPop=1');
      }
    }
  };

  /**
   * 페이지 파라미터를 관리하는 params을 수정하는 함수
   * @param newParams
   */
  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  const handleGraphLoading = (state) => {
    dispatch(graphChangeLoading(state));
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          useExternalFilter={false}
        />
      </NewFilterWrap>
      <StatisticsMonthGraph
        params={params}
        handleGraphLoading={handleGraphLoading}
      />
      <NewTableContainer
        params={params}
        getParam={getParam}
        dataReqPromise={localMonthReport}
        customized={customized}
        expandTable
        useSearch={false}
        useFetch={false}
      />
    </>
  );
};

export default withRouter(StatisticsMonth);
